import { Role, ADMIN_ROLES, STOCK_ROLES } from '@/constants/roles';
import { Permission } from '@/constants/permissions';

export interface UserInfo {
  id?: string;
  username?: string;
  role?: string;
  workshopId?: string | null;
  permissions?: string[];
}

export function hasRole(user: UserInfo | null | undefined, roles: string[]): boolean {
  if (!user || !user.role) return false;
  return roles.includes(user.role);
}

export function isAdmin(user: UserInfo | null | undefined): boolean {
  return hasRole(user, ADMIN_ROLES);
}

export function canAccessStock(user: UserInfo | null | undefined): boolean {
  return hasRole(user, STOCK_ROLES);
}

export function canManageUsers(user: UserInfo | null | undefined): boolean {
  return isAdmin(user);
}

/**
 * 判断用户是否拥有指定权限点
 * - admin 默认拥有所有权限
 * - 支持通配符 '*' 表示拥有所有权限
 */
export function hasPermission(
  user: UserInfo | null | undefined,
  permission: Permission | string,
): boolean {
  if (!user) return false;
  if (isAdmin(user)) return true;

  const userPermissions = user.permissions || [];
  if (userPermissions.includes('*')) return true;

  return userPermissions.includes(permission);
}

/**
 * 判断用户是否拥有指定权限点中的任意一个
 */
export function hasAnyPermission(
  user: UserInfo | null | undefined,
  permissions: (Permission | string)[],
): boolean {
  return permissions.some((permission) => hasPermission(user, permission));
}

export { Permission };
